module.exports = __webpack_public_path__ + "img/k_enlarge_pink.04a28ba3.png";